import FooterBottom from './FooterBottom'
import { FooterContactRow } from './FooterContact'
import FooterLogo from './FooterLogo'
import FooterNav from './FooterNav'
import { useFooterData } from './useFooterData'
import './footerShared.css'
import './FooterCenteredLight.css'

function FooterCenteredLayout({ config, variant, showSocial }) {
  const { brand, contact, nav, social, year, poweredBy, description } = useFooterData(config)
  const themeClass = variant === 'dark' ? 'footer--centered-dark' : 'footer--centered-light'

  return (
    <footer id="contacto" className={`footer ${themeClass}`}>
      <div className="footer__container">
        <div className="footer__brand">
          <FooterLogo brand={brand} variant={variant} centered />
          {description ? <p className="footer__description">{description}</p> : null}
        </div>
        <FooterNav items={nav} layout="row" variant={variant} />
        <FooterContactRow contact={contact} variant={variant} />
        <FooterBottom
          brandName={brand.name || 'Workit'}
          year={year}
          poweredBy={poweredBy}
          social={social}
          variant={variant}
          showSocial={showSocial}
        />
      </div>
    </footer>
  )
}

export default FooterCenteredLayout
